import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { MANAGE_ALARM_GATEWAY_LIST } from './url-constants';

type ManageAlarmsGatewayListEndpointSpecification = ApiEndpointSpecification;
export const ManageAlarmsGatewayListEndpointSpecification: ManageAlarmsGatewayListEndpointSpecification = {
    url: MANAGE_ALARM_GATEWAY_LIST,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'ManageAlarmsGatewayListRequestParams',
    requestBodySchemaName: 'ManageAlarmsGatewayListRequestBody',
    okResponseSchemaName: 'ManageAlarmsGatewayListOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version:3
};

export const invokeManageAlarmsGatewayList = Helpers.makeApiRequestFn<
    Types.ManageAlarmsGatewayListRequestParams,
    Types.ManageAlarmsGatewayListRequestBody,
    Types.ManageAlarmsGatewayListOkResponse
>(ManageAlarmsGatewayListEndpointSpecification);
